/* Proof-only kernel motion. Scores and trajectories are not inputs to randomness. */
(function(host){
  'use strict';
  const clamp=(x,a,b)=>Math.min(b,Math.max(a,x));
  function rng(seed){let a=seed>>>0;return()=>{a+=0x6D2B79F5;let t=a;t=Math.imul(t^(t>>>15),t|1);t^=t+Math.imul(t^(t>>>7),t|61);return((t^(t>>>14))>>>0)/4294967296;};}
  function create(seed){
    const r=rng(seed),between=(a,b)=>a+(b-a)*r();
    return {seed:seed>>>0,direction:r()<.5?-1:1,turns:between(1.3,2.7),start:between(-12,12),spinWobble:between(35,85),flutter:between(2.2,4.2),phase:between(0,Math.PI*2),side:between(12,25),bob:between(5,13),skew:between(3,9)};
  }
  function sample(p,progress,reduced=false){
    const t=clamp(progress,0,1),envelope=t===0||t===1?0:Math.pow(Math.sin(Math.PI*t),1.3),depth=1-t*.35;
    if(reduced)return {dx:0,dy:0,angle:0,sx:depth,sy:depth,skew:0};
    return {
      dx:envelope*p.side*Math.sin(t*Math.PI*2*p.flutter+p.phase),
      dy:envelope*p.bob*Math.sin(t*Math.PI*2*(p.flutter+.65)),
      angle:p.start+p.direction*(360*p.turns*(.62*t+.38*t*t)+envelope*p.spinWobble*Math.sin(t*Math.PI*4+p.phase)),
      sx:depth*(1-.73*envelope*Math.pow(Math.sin(t*Math.PI*p.flutter),2)),
      sy:depth*(1+.09*envelope*Math.sin(t*Math.PI*2*p.flutter+p.phase)),
      skew:envelope*p.skew*Math.sin(t*Math.PI*2*(p.flutter+.4)+p.phase)
    };
  }
  function path(origin,end,t){
    const u=1-t,lift=clamp(Math.hypot(end.x-origin.x,end.y-origin.y)*.42,240,500),control={x:(origin.x+end.x)/2,y:Math.max(-60,Math.min(origin.y,end.y)-lift)};
    return {x:u*u*origin.x+2*u*t*control.x+t*t*end.x,y:u*u*origin.y+2*u*t*control.y+t*t*end.y,control};
  }
  const api={create,sample,path};if(typeof module==='object'&&module.exports)module.exports=api;else host.PopKernelMotion=api;
})(typeof window==='undefined'?globalThis:window);

/* Same approved presentation module in the outcome demo. */
(() => {
  const SELECTOR = '[data-pop-shot-game]';
  const SHOTS = {
    glass: {
      path: 'M 1575 865 Q 1320 -380 884 385',
      label: 'SHOT GLASS',
      rule: 'glass'
    },
    far: {
      path: 'M 1575 865 Q 1340 -350 389 301',
      label: 'CORNHOLE',
      rule: 'far'
    },
    miss: {path:'M 1575 865 Q 1100 -120 580 700',label:'MISS = SIP',rule:'miss'},
    own: {
      path: 'M 1575 865 Q 1450 420 1334 675',
      label: 'OWN HOLE = SIP',
      rule: 'miss'
    }
  };

  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealCaption(root, shot) {
    const caption = root.querySelector('[data-pop-shot-caption]');
    const label = root.querySelector('[data-pop-shot-caption-label]');
    const message = root.querySelector('[data-pop-shot-caption-message]');
    if (!caption || !label || !message) return;

    label.textContent = shot.label;
    const source=root.closest('[data-pop-document-root]').querySelector('[data-pop-rule="'+shot.rule+'"] span');
    message.textContent = source.textContent;
    caption.classList.remove('is-visible');
    window.requestAnimationFrame(() => caption.classList.add('is-visible'));
  }

  function setKernelPosition(kernel, point, motion) {
    kernel.setAttribute('transform', `translate(${point.x+motion.dx} ${point.y+motion.dy}) rotate(${motion.angle}) skewX(${motion.skew}) scale(${motion.sx} ${motion.sy})`);
  }

  function fire(root, key) {
    const shot = SHOTS[key];
    const trail = root.querySelector('[data-pop-shot-trail]');
    const kernel = root.querySelector('[data-pop-shot-kernel]');
    const caption = root.querySelector('[data-pop-shot-caption]');
    if (!shot || !trail || !kernel || !caption) return;

    if (root._popShotFrame) window.cancelAnimationFrame(root._popShotFrame);
    root.dataset.activeShot = key;
    root.querySelectorAll('[data-pop-shot]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.popShot === key));
    });

    caption.classList.remove('is-visible');
    trail.setAttribute('d', shot.path);
    const length = trail.getTotalLength();
    trail.style.strokeDasharray = `${length}`;
    trail.style.strokeDashoffset = `${length}`;
    const endpoint = trail.getPointAtLength(length);

    const seed=new Uint32Array(1);crypto.getRandomValues(seed);
    const tumble=window.PopKernelMotion.create(seed[0]);
    if (reducedMotion()) {
      setKernelPosition(kernel, endpoint, window.PopKernelMotion.sample(tumble,1,true));
      trail.style.strokeDashoffset = '0';
      revealCaption(root, shot);
      return;
    }

    const start = performance.now();
    const duration = 1050;
    const animate = (time) => {
      const progress = Math.min(1, (time - start) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      const point = trail.getPointAtLength(length * eased);
      setKernelPosition(kernel, point, window.PopKernelMotion.sample(tumble,eased));
      trail.style.strokeDashoffset = `${length * (1 - eased)}`;

      if (progress < 1) {
        root._popShotFrame = window.requestAnimationFrame(animate);
      } else {
        root._popShotFrame = null;
        window.setTimeout(() => revealCaption(root, shot), 110);
      }
    };

    root._popShotFrame = window.requestAnimationFrame(animate);
  }

  function initialize(root) {
    if (!root || root.dataset.popShotReady === 'true') return;
    root.dataset.popShotReady = 'true';
    root.dataset.activeShot = 'glass';

    root.querySelectorAll('[data-pop-shot]').forEach((button) => {
      button.addEventListener('click', () => fire(root, button.dataset.popShot));
    });

    if (reducedMotion() || !('IntersectionObserver' in window)) {
      fire(root, 'glass');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      fire(root, 'glass');
    }, { threshold: 0.45 });
    observer.observe(root);
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
